export default {
    JUXTAPOSITION: 'juxtaposition',
    AREA_CHART: 'Area Chart',
    VERTICAL_BAR_CHART: 'Vertical Bar Chart',
    VERTICAL_DIFFERENCE_BAR_CHART: 'Vertical Difference Bar Chart',
    VERTICAL_DIFFERENCE_ARROW_CHART: 'Vertical Difference Arrow Chart',
    HORIZONTAL_BAR_CHART: 'Horizontal Bar Chart',
    PROGRESS_BAR_CHART: 'Progress Bar Chart',
    STACKED_BAR_CHART: 'Stacked Bar Chart',
    ISOTYPE_BAR_CHART: 'Isotype Bar Chart',
    PROPORTION_ISOTYPE_CHART: 'Proportion Isotype Chart',
    COLOR_FILLING_MAP: 'Color Filling Map',
    BUBBLE_CHART: 'Bubble Chart',
    TEXT_CHART: 'Text Chart',
    LINE_CHART: 'Line Chart',
    STACKED_LINE_CHART: 'Stacked Line Chart',
    RING_CHART: 'Ring Chart',
    HALF_RING_CHART: 'Half Ring Chart',
    PIE_CHART: 'Pie Chart',
    SCATTER_PLOT: 'Scatter Plot',
    TREE_MAP: 'Treemap',
    BUBBLE_MAP: 'Bubblemap'
}